import React from 'react';
import classNames from 'classnames';
import { XOR } from '../../types';
import { Button } from 'ncoded-component-library';
import InformationcircleIcon from '../../icons/Informationcircle.icon';
import XIcon from '../../icons/X.icon';

import './HintMessage.styles.scss';

type HintMessageType = 'default' | 'error' | 'info' | 'success';

type WithAction = {
  actionButtonText: string;
  actionButtonIcon?: React.ReactNode;
  actionButtonVariant?: 'outline' | 'solid';
  onActionClick: () => void;
};

type WithoutAction = {
  withAction?: false;
};

type HintMessageProps = {
  className?: string;
  title?: string;
  type?: HintMessageType;
  message?: React.ReactNode;
  icon?: React.ReactNode;
  // Pass to make the message dismissible - the caller owns what dismissing means.
  onClose?: () => void;
} & XOR<WithAction, WithoutAction>;

const HintMessage: React.FC<HintMessageProps> = (props) => {
  const {
    className,
    title,
    message,
    actionButtonText,
    actionButtonIcon,
    actionButtonVariant = 'solid',
    type = 'default',
    icon = <InformationcircleIcon />,
    onActionClick,
    onClose,
  } = props;

  const classes = classNames('hint-message', type, className);

  return (
    <div className={classes}>
      {icon}
      <div className="hint-message__content">
        {title && <p className="hint-message__content__title">{title}</p>}
        <div>{message}</div>
        {actionButtonText && (
          <Button
            variant={actionButtonVariant}
            icon={actionButtonIcon}
            onClick={() => (onActionClick as () => void)()}
          >
            {actionButtonText}
          </Button>
        )}
      </div>

      {onClose && (
        <Button
          variant="icon"
          aria-label="Close"
          className="hint-message__close"
          icon={XIcon}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default HintMessage;
